import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { ApiConstants } from 'src/app/common/constants/api-url.constant';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(private storageService: LocalStorageService, private http: HttpClient) {

  }

  getShopsList(param?:any): Observable<any> {
    return this.http.get(ApiConstants.GET_MERCHANT(param));
  }

  getCountries(): Observable<any> {
    return this.http.get(ApiConstants.GET_COUNTRY);
  }
  getCategories(): Observable<any> {
    return this.http.get(ApiConstants.GET_CATEGORY);
  }

  getBusinessType(): Observable<any> {
    return this.http.get(ApiConstants.GET_BUSINESS_TYPE);
  }

  getAnnulaSales(): Observable<any> {
    return this.http.get(ApiConstants.GET_ANNUAL_SALES);
  }

  getAverageOrder(): Observable<any> {
    return this.http.get(ApiConstants.GET_AVERAGE_ORDER_VALUE);
  }
  getPlatform(): Observable<any> {
    return this.http.get(ApiConstants.GET_PLATFORM);
  }
  merchantSign_Up(request:any): Observable<any> {
    return this.http.post(ApiConstants.MERCHANT_INFO, request);
  }

}
